export default __webpack_public_path__ + "static/media/avatar.a7174e0a.svg";